const module = {
  config: {
    name: 'configuration',
    icon: 'ri-settings-line',
    desc: 'PMIS Infrastruktur II',
    layout: true
  },
  routes: [
    { name: 'config-projects', label: 'Unlock Form Proyek', icon: null, path: '/config-projects', component: () => import('./config-projects.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/config-input/_index.js